import React from 'react'
import AddIcon from '@material-ui/icons/Add'
import styled from 'styled-components'
import { Box, Grid } from 'core/components/Core'

const OutlineOff = styled(Grid)`
  &:focus {
    outline: none;
  }
`

const CardDropZone = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.background.default};
  border-radius: 9px;
  border: 1px dashed ${props => props.theme.palette.grey[400]};
  box-sizing: border-box;
  cursor: pointer;
  cursor: pointer;
  display: flex;
  height: 106px;
  width: 106px;
  justify-content: center;
  line-height: 0;
  text-align: center;
  transition: border-color 0.3s;
  vertical-align: top;
`

const DropZone = styled(({ error, ...otherProps }) => <Box {...otherProps} />)`
  padding: 16px 0;
  cursor: pointer;
  background: ${props => props.theme.palette.background.default};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='${props =>
    props.error
      ? '%23E12A45'
      : '%23333'}' stroke-width='1' stroke-dasharray='7%2c 7' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 4px;
`

const TextHighlight = styled.span`
  color: ${props => props.theme.palette.primary.main};
`

const StyledAddIcon = styled(AddIcon)`
  color: ${props => props.theme.palette.grey[400]};
`

export { OutlineOff, DropZone, TextHighlight, CardDropZone, StyledAddIcon }
